<script>
import { Pie, mixins } from 'vue-chartjs'

export default {
    name: 'PieChart',
    extends: Pie,
    mixins: [mixins.reactiveProp],
    props: {
        chartData: {
            type: Object,
        },
    },

    mounted() {
        this.renderChart(this.chartData, {
            responsive: true,
            maintainAspectRatio: true,
            legend: {
                display: false,
            },
            tooltips: {
                callbacks: {
                    label: (tooltipItem, data) => {
                        const dataset = data.datasets[tooltipItem.datasetIndex];
                        const value = dataset.data[tooltipItem.index];
                        const label = data.labels[tooltipItem.index];
                        const total = dataset.data.reduce((acc, v) => acc + v, 0);
                        const pct = ((value / total) * 100).toFixed(1);
                        return `${label}: $${Math.round(value).toLocaleString()} (${pct}%)`;
                    },
                },
            },
        });
    },
};
</script>
